import {
  Dialog,
  IconButton,
  Stack,
  Typography
} from '@mui/material'
import { Close } from '@mui/icons-material'
import MicrosoftCalendar from './MicrosoftCalendar'
import GoogleCalendarLogin from './GoogleCalendar'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import { useTranslation } from 'react-i18next'

const LinkCalendarDialog = ({
  handleSigninResult,
  dialogOpen,
  setDialogOpen
}) => {
  const { t } = useTranslation()
  return (
    <Dialog onClose={() => setDialogOpen(false)} open={dialogOpen}>
      <Stack spacing={8} padding={8}>
        <RowStack justifyContent={'space-between'}>
          <Typography variant='h4'>
            {t('calendarEvents.linkMyCalendar')}
          </Typography>

          <IconButton
            sx={{
              float: 'right',
              paddingTop: '2px',
              color: colors.LightGrey400
            }}
            onClick={() => setDialogOpen(false)}>
            <Close />
          </IconButton>
        </RowStack>
        <MicrosoftCalendar signinCallback={handleSigninResult} />
        <GoogleCalendarLogin signinCallback={handleSigninResult} />
      </Stack>
    </Dialog>
  )
}

export default LinkCalendarDialog
